import { Pagination } from 'react-bootstrap';
import ContactForm from '../../components/ContactForm';
import { useState, useEffect } from 'react';
import { appType, contactType } from '../../components/constant';
import { StyledPagination } from '../../StyledComponets';
import CustomerProgram from '../../components/CustomerPrograms';
import UploadDoc from '../../components/UploadDocs';
import { CNT_KEY } from '../../components/ContactForm/helpers';
import {
  buildIcxAppRequest,
  reBuildCntGenData,
  reBuildCustomerData,
  rebuildProgramState,
} from './apiHelpers';
import { useDispatch, useSelector } from 'react-redux';
import {
  getProjectData,
  createProjectData,
  resetProjectStateReducer,
} from '../../app/projects/createProjectSlice';
import withLayout from '../../components/Layout/withLayout';
import Invoiceinfo from '../../components/InvoiceInfo';
import { fetchUserDetails, getUserData } from '../../app/environment/userSlice';
import Notes from '../../components/Notes';
import { resetCityStateReducer } from '../../app/contact/contactSlice';
import { resetCustomerDataReducer } from '../../app/contact/getCustomerSlice';
import NotesForm from '../../components/Notes/NotesForm';

export function InterconnectHome(props) {
  const { isClickable, pageType, detailsData } = props;
  const [pageactive, setActivePage] = useState(1);
  const [sectionData, setSectionData] = useState([]);
  const dispatch = useDispatch();
  const projectData = useSelector(getProjectData);
  const userData = useSelector(getUserData);


  const setActiveAndDisabledProps = (sectionKey) => {
    return {
      active: pageactive === sectionKey,
      disabled: isClickable ? false : pageactive !== sectionKey,
      ...(isClickable
        ? {
            onClick: onSectionClick,
          }
        : {}),
    };
  };

  const onSectionClick = (e) => {
    setActivePage(e.target.tabIndex);
    //CALL API TO GET DEATILS
  };

  useEffect(() => {
    if(!userData){
      dispatch(fetchUserDetails());
    }  
    return () => {
      resetAppState();
    };
  }, []);

  const resetAppForm = () => {
    setSectionData([]);
    setActivePage(1);
  };

  const resetAppState = () =>{
    dispatch(resetCityStateReducer());
    dispatch(resetProjectStateReducer());
    dispatch(resetCustomerDataReducer())
  }

  const setSection = (isNext, data) => {
    //SET SECTION DATA ON CLICK
    const sectionItem = sectionData.find((x) => x.id === pageactive);
    const sIndex = sectionData.indexOf(sectionItem);
    if (sIndex >= 0) {
      const updateItem = {
        ...sectionItem,
        ...(data ? { data: data } : {}),
      };
      const newState = [...sectionData];
      newState[sIndex] = updateItem;
      setSectionData(newState);
    } else {
      setSectionData([...sectionData, { id: pageactive, data: data }]);
    }
    //SET NEXT OR PREVIOUS SECTION
    isNext ? setActivePage(pageactive + 1) : setActivePage(pageactive - 1);
  };

  const setPreviousData = (isApplicant, data) => {
    const sid = isApplicant ? 1 : 2;
    const previousData = sectionData.find((x) => x.id === sid);
    delete previousData.data[CNT_KEY.SAME_CD];

    const sectionItem = sectionData.find((x) => x.id === pageactive);
    const sIndex = sectionData.indexOf(sectionItem);
    if (sIndex >= 0) {
      const updateItem = {
        ...sectionItem,
        data: data ?? previousData?.data,
      };
      const newState = [...sectionData];
      newState[sIndex] = updateItem;
      setSectionData(newState);
    } else {
      setSectionData([
        ...sectionData,
        { id: pageactive, data: data ?? previousData?.data },
      ]);
    }
  };

  const createOrSaveProject = (programData, actionType) => {
    const programDt = sectionData.find((x) => x?.id === 4)?.data;
    const reqObj = buildIcxAppRequest(
      projectData,
      sectionData,
      appType.ICX,
      programData ?? programDt,
      userData,
      actionType
    );
    dispatch(createProjectData(reqObj));
  };

  return (
    <>
      <StyledPagination>
        <Pagination.Item {...setActiveAndDisabledProps(1)} tabIndex={1}>
          Customer Information
        </Pagination.Item>
        <Pagination.Item {...setActiveAndDisabledProps(2)} tabIndex={2}>
          Applicant Information
        </Pagination.Item>
        <Pagination.Item {...setActiveAndDisabledProps(3)} tabIndex={3}>
          Contractor Information
        </Pagination.Item>
        <Pagination.Item {...setActiveAndDisabledProps(4)} tabIndex={4}>
          Customer Programs
        </Pagination.Item>
        <Pagination.Item {...setActiveAndDisabledProps(5)} tabIndex={5}>
          {isClickable ? 'Documents' : 'Upload Documents'}
        </Pagination.Item>
        {!isClickable && (
          <Pagination.Item {...setActiveAndDisabledProps(6)} tabIndex={6}>
            Additional Information and Details
          </Pagination.Item>
        )}
        {isClickable && (
          <>
            <Pagination.Item {...setActiveAndDisabledProps(6)} tabIndex={6}>
              Invoice information
            </Pagination.Item>
            <Pagination.Item {...setActiveAndDisabledProps(7)} tabIndex={7}>
              Additional Information and Details
            </Pagination.Item>
          </>
        )}
      </StyledPagination>
      {pageactive === 1 && (
        <ContactForm
          key={1}
          type={contactType.customer}
          setSection={setSection}
          formData={
            isClickable
              ? {
                  data: reBuildCustomerData(detailsData?.appEnrollmentSummary),
                }
              : sectionData.find((x) => x?.id === 1)
          }
          isProjectDetailsView={isClickable}
          pageType={pageType}
          noBack={true}
          showAccount={true}
          showPosition={true}
        />
      )}
      {pageactive === 2 && (
        <ContactForm
          key={2}
          type={contactType.applicant}
          setSection={setSection}
          formData={
            isClickable
              ? {
                  data: reBuildCntGenData(
                    detailsData?.appEnrollmentSummary?.applicant
                  ),
                }
              : sectionData.find((x) => x?.id === 2)
          }
          isProjectDetailsView={isClickable}
          pageType={pageType}
          showCommonForm={true}
        />
      )}
      {pageactive === 3 && (
        <ContactForm
          key={3}
          type={contactType.installer}
          setSection={setSection}
          formData={
            isClickable
              ? {
                  data: reBuildCntGenData(
                    detailsData?.appEnrollmentSummary?.installer
                  ),
                }
              : sectionData.find((x) => x?.id === 3)
          }
          setPreviousData={setPreviousData}
          isProjectDetailsView={isClickable}
          pageType={pageType}
          showCommonForm={true}
        />
      )}
      {pageactive === 4 && (
        <CustomerProgram
          key={4}
          setSection={setSection}
          formData={
            isClickable
              ? {
                  data: detailsData?.customerPrograms.map((pgm) =>
                    rebuildProgramState(pgm)
                  ),
                }
              : sectionData.find((x) => x?.id === 4)
          }
          pageType={pageType}
          createOrSaveProject={createOrSaveProject}
        />
      )}
      {pageactive === 5 && (
        <UploadDoc
          key={5}
          setSection={setSection}
          appData={detailsData?.appEnrollmentSummary}
          formData={
            isClickable
              ? { data: detailsData?.agreementAttachments }
              : sectionData.find((x) => x?.id === 5)
          }
          createOrSaveProject={createOrSaveProject}
          resetAppForm={resetAppForm}
          isProjectDetailsView={isClickable}
          pageType={pageType}
        />
      )}
      {pageactive === 6 && !isClickable && (
        <NotesForm
        key={6}
        setSection={setSection}
        formData={ sectionData.find((x) => x?.id === 6)}
        createOrSaveProject={createOrSaveProject}
        />
      )} 
      {pageactive === 6 && isClickable && (
        <Invoiceinfo
          invData={detailsData?.invoices?.length ? detailsData?.invoices : []}
        />
      )}
      {pageactive === 7 && isClickable && <Notes pageType={pageType} />}
    </>
  );
}

export default withLayout(InterconnectHome);
